import axios from 'axios'

export default async function getModelCollection(path, Model, query = {}) {
  return axios
    .get(`${path}.json`, { params: query })
    .then(({ data }) => {
      const instances = data[Model.pluralCamelFullName].map((attributes) => {
        return new Model(attributes);
      });

      return { ...data, [Model.pluralCamelFullName]: instances };
    }).catch((data) => {
      console.log("data", data)
      return { error: true }
    });
}
